import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Es material digital?',
  a: 'Sí, accedés desde cualquier dispositivo con internet. Lo recibís en tu mail y podés descargarlo a tu computadora, tablet o celular.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Recibís el acceso por email apenas se confirma el pago. Es inmediato: si pagás de noche, lo tenés esa misma noche. Sin esperas.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí, todo el material está optimizado para imprimir y llevar a la cancha. Los archivos son PDFs de alta calidad.'
}, {
  q: '¿Sirve para cualquier club?',
  a: 'Sí, está pensado para clubes, escuelitas, colonias y profes particulares. Cada propuesta trae variantes para adaptarla a la realidad de tu grupo.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. El sistema te guía paso a paso, desde el calentamiento hasta la vuelta a la calma. Las consignas son claras y fáciles de aplicar.'
}, {
  q: '¿Puedo usarlo toda la temporada?',
  a: 'Sí, son 240 semanas, suficiente para varias temporadas completas sin repetir entrenamientos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-24 bg-white" data-id="element-41">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-43">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-50 text-brand-700 font-bold text-xs uppercase tracking-wider mb-5 border border-brand-100" data-id="element-44">
            Preguntas frecuentes
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-45">
            Resolvemos tus <span className="text-brand-500" data-id="element-46">dudas</span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-47">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} className={`bg-white rounded-2xl border transition-all overflow-hidden ${open ? 'border-brand-300 shadow-card' : 'border-ink-100 shadow-soft'}`} data-id="element-48">
                <button onClick={() => setOpenIndex(open ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none gap-4" aria-expanded={open} data-id="element-49">
                  <span className="font-bold text-ink-900 text-base lg:text-lg" data-id="element-50">
                    {faq.q}
                  </span>
                  <div className={`w-9 h-9 rounded-full flex items-center justify-center transition-all shrink-0 ${open ? 'bg-brand-500 text-white rotate-45' : 'bg-ink-50 text-ink-700'}`} data-id="element-51">
                    <Plus className="w-4 h-4" strokeWidth={3} data-id="element-52" />
                  </div>
                </button>
                <AnimatePresence data-id="element-53">
                  {open && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-54">
                      <div className="px-6 pb-6 text-ink-600 leading-relaxed" data-id="element-55">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}